import { useContext } from "react";
import AuthContext from "../../../context/auth/AuthContext";
import { haveValue } from "../../../helper/common";
import useTranslator from "../../../hooks/useTranslator";
import PropertyRow from "./PropertyRow";

const PropertyTable = ({
  property,
  onPropertyAward,
  tanentData,
  loadData,
  propId,
  setSearchPropId,
  loading = false,
}) => {
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const { user } = authContext;

  return (
    <div className="profile-table-scroll">
      <table className="profile-table property-table">
        <thead className="hideOnMobile">
          <tr>
            <th className="property-col">{_t("property")}</th>
            <th>{_t("municipality", "Field in properties table")}</th>
            <th>{_t("postCode", "Field in properties table")}</th>
            <th>{_t("estimatedRent")}</th>
            <th>{_t("linkedTo", "Field in properties table")}</th>
            <th>{_t("sourceId", "Field in properties table")}</th>
            <th>{_t("userName", "Field in properties table")}</th>
            <th className="action-col"></th>
          </tr>
        </thead>

        <tbody>
          {Array.isArray(property) &&
            property.length > 0 &&
            property.map((data) => (
              <PropertyRow
                key={data?._id || data?.id}
                data={data}
                onPropertyAward={onPropertyAward}
                tanentData={tanentData}
                loadData={loadData}
                user={user}
                propId={propId}
                setSearchPropId={setSearchPropId}
                openLinkedPopup={propId === data._id}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default PropertyTable;
